<template>
	<div class="contentPage">
		<main-table-all-back
				v-if="incomeTransactionsLimit"
				textCreate="Add driver"
				:flag="flag"
				page-title="Income transactions"
				:headers="incomeTransactionsHeaders"
				:settings="incomeTransactionsSettings"
				:filtersList="incomeTransactionsFilters"
				:list="incomeTransactionsList"
				:defaultOrder="incomeTransactionsOrder"
				:defaultSort="incomeTransactionsSort"

				:totals="incomeTransactionsTotals"
				:total-pages="incomeTransactionsTotal"
				:limit-pages="incomeTransactionsLimit"
				:pages="[ 20, 50, 100, 200, 500, 'All' ]"
				:uniqId="uniqId"
				@updateSettings="onSettingsOpen"
				@updateEvent="onEvent"
				@updateClickButton="onClickButton"
				@updateList="onList"
				@updateEdit="onEdit"
				@updateRefreshFilters="onUpdateFilters(defaultFilter)"
				@updateExport="onExport"
				isExport
				:is-create="false"
				:permissionsCreate="permissionsCreate()"
				is-settings

				:externalRefreshKey="externalRefreshKey"
				:externalResetKey="externalResetKey"
				:externalResetMode="externalResetMode"
		>
			<template slot="subTitle">

			</template>
			<template slot="customButtons">
				<div
						v-if="incomeTransactionsUpdate"
						class="incomeTransactionsUpdate"
				>
					<div class="incomeTransactionsUpdate__content">
						<div class="incomeTransactionsUpdate__head">
							<v-icon class="incomeTransactionsUpdate__icon">
								mdi-update
							</v-icon>

							<div class="incomeTransactionsUpdate__text">
								Last update at
							</div>

							<div class="incomeTransactionsUpdate__date">
								{{ incomeTransactionsUpdateFormatted.date }}
							</div>
						</div>

						<div class="incomeTransactionsUpdate__zones">
							<div
									v-for="zone in incomeTransactionsUpdateFormatted.zones"
									:key="zone.code"
									class="incomeTransactionsUpdate__zone"
							>
								<span class="incomeTransactionsUpdate__zoneCode">
									{{ zone.code }}
								</span>

								<span class="incomeTransactionsUpdate__zoneTime">
									{{ zone.time }}
								</span>
							</div>
						</div>
					</div>
				</div>

				<v-btn
						color="success"
						:loading="isRefreshLoading"
						:disabled="isRefreshLoading"
						@click="openRefresh"
				>
				  <span class="btnText">
				    Update list
				  </span>
				</v-btn>
			</template>

		</main-table-all-back>

		<bank-sync-loader
				:value="isRefreshLoading"
				:text="refreshLoadingText"
		/>

		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('incomeTransactions')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="incomeTransactionsSettings"
		/>
		
		<remove-block
				v-if="isRemove"
				@updateRemoveItem="onRemoveItem"
				@updateRemoveClose="onRemoveClose"
		></remove-block>
<!--		<incomeTransactions-form-->
<!--				v-if="isIncomeTransactionsForm"-->
<!--				:permissions="permissions"-->
<!--				:id="id"-->
<!--				@updateClose="onCloseDialog"-->
<!--		></incomeTransactions-form>-->
		<preview-document v-if="previewLink"></preview-document>

		<edit-transactions
				v-if="isEditTransactions"
				:customers="incomeTransactionsCustomers"
				:item="incomeTransactionsRow"
				@updateClose="onCloseEditTransactions"
				@updateSave="onSaveEditTransactions"
		/>

		<paid-transactions
				v-if="isPaidTransactions"
				:data="paidTransactionsData"
				@updateClose="onClosePaidTransactions"
		/>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
// import IncomeTransactionsForm from "@/components/Maintenance/IncomeTransactions/IncomeTransactionsForm/IncomeTransactionsForm";
// shared
import PreviewDocument from "@/shared/PreviewDocument/PreviewDocument";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack";
// mixins
import settingsMixins from "@/mixins/settingsMixins";
import removeMixins from "@/mixins/removeMixins";
// constants
import { PAGE, PERMISSIONS } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import getUniqId from "@/helper/getUniqId";
import BankSyncLoader from "@/pages/Accounting/IncomeTransactions/BankSyncLoader.vue";
import EditTransactions from "@/pages/Accounting/IncomeTransactions/EditTransactions.vue";
import PaidTransactions from "@/pages/Accounting/IncomeTransactions/PaidTransactions.vue";

export default {
	name: "IncomeTransactions",
	mixins: [ settingsMixins, removeMixins ],
	components: {
		PaidTransactions,
		EditTransactions,
		BankSyncLoader,
		PreviewDocument,
		MainTableAllBack,
		// IncomeTransactionsForm
	},
	computed: {
		...mapGetters([
			"incomeTransactionsList",
			"incomeTransactionsFilters",
			"incomeTransactionsTotals",
			"permissions",
			"incomeTransactionsOrder",
			"incomeTransactionsLimit",
			"incomeTransactionsSort",
			"incomeTransactionsUpdate",
			"incomeTransactionsTotal",
			"previewLink",
			"permissionsDefault",
			"role",
			"incomeTransactionsCustomers",
			"incomeTransactionsRow",
			"paidTransactionsData",

		]),

		incomeTransactionsHeaders() {
			const hiddenFields = [
				'amount',
				'invoice_id',
				'paid',
				'customer_payments_id'
			];

			if (Number(this.role) !== 7) {
				return this.headers;
			}

			return this.headers.filter(item => {
				if (item.buttons) {
					return false;
				}

				return !hiddenFields.includes(item.value);
			});
		},

		incomeTransactionsSettings() {
			const hiddenFields = [
				'amount',
				'invoice_id',
				'paid',
				'customer_payments_id'
			];

			if (Number(this.role) !== 7) {
				return this.getSettings;
			}

			return this.getSettings.filter(item => {
				if (item.buttons) {
					return false;
				}

				return !hiddenFields.includes(item.value);
			});
		},

		incomeTransactionsUpdateFormatted() {
			if (!this.incomeTransactionsUpdate) {
				return {
					date: '',
					zones: [],
				};
			}

			let value = this.incomeTransactionsUpdate;

			// Backend возвращает UTC без timezone:
			// 2026-09-08 07:28:46
			if (
				typeof value === 'string'
					&& !value.endsWith('Z')
					&& !/[+-]\d{2}:\d{2}$/.test(value)
			) {
				value = `${ value.replace(' ', 'T') }Z`;
			}

			const date = new Date(value);

			if (Number.isNaN(date.getTime())) {
				return {
					date: this.incomeTransactionsUpdate,
					zones: [],
				};
			}

			const formatTime = timeZone => {
				return date.toLocaleTimeString('en-US', {
					timeZone,
					hour: 'numeric',
					minute: '2-digit',
					// second: '2-digit',
					hour12: true,
				});
			};

			return {
				date: date.toLocaleDateString('en-US', {
					timeZone: 'America/Chicago',
					month: '2-digit',
					day: '2-digit',
					year: 'numeric',
				}),

				zones: [
					{
						code: 'PT',
						time: formatTime('America/Los_Angeles'),
					},
					{
						code: 'MT',
						time: formatTime('America/Denver'),
					},
					{
						code: 'CT',
						time: formatTime('America/Chicago'),
					},
					{
						code: 'ET',
						time: formatTime('America/New_York'),
					},
					{
						code: 'GET',
						time: formatTime('Asia/Tbilisi'),
					},
				],
			};
		},
	},
	data: () => ({
		isIncomeTransactionsForm: false,
		defaultFilter: null,
		activeTableFilters: null,
		id: null,

		isRefreshLoading: false,
		refreshLoadingText: "Receiving latest data from the bank...",

		externalRefreshKey: null, // Обновление списка с фильтрами
		externalResetKey: null, // Сброс фильтров
		externalResetMode: 'default', // Тип сброса фильтров ('default' сброс до дефолтніх фильтров) | ('empty' спрос всех фильтров)

		isEditTransactions: false,
		flag: PAGE.INCOME_TRANSACTIONS,
		isPaidTransactions: false,
	}),
	methods: {
		...mapActions([
			'getIncomeTransactions',
			'getIncomeTransactionsFilters',
			'actionPreloader',
			'onExportLink',
			'onIncomeTransactionsRemoveItem',
			'getRefresh',
			'onEditIncomeTransactions',
			'onUpdateIncomeTransactions',
			'getPaidTransactionsData',
		]),
		async openRefresh() {
			if (this.isRefreshLoading) {
				return;
			}

			this.isRefreshLoading = true;

			try {
				this.refreshLoadingText = 'Receiving latest bank transactions...';

				await this.getRefresh();

				this.refreshLoadingText = 'Updating Fleet transaction list...';

				await this.onUpdateFilters(this.activeTableFilters);
			} catch (error) {
				console.error(error);

				this.$store.dispatch('setAlert', {
					type: 'error',
					message: 'Failed to update transactions from the bank',
				});
			} finally {
				this.isRefreshLoading = false;
			}
		},
		permissionsCreate() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.MAINTENANCE, PERMISSIONS.DRIVERS, PERMISSIONS.CREATE ];
			return !getPermissionsMod({ list, path });
		},
		onCloseDialog(isRefresh) {
			this.isIncomeTransactionsForm = false;
			if (isRefresh) {
				// this.onUpdateFilters(this.defaultFilter);
				this.externalRefresh();
			}
		},
		async onRemoveItem() {
			const { status } = await this.onIncomeTransactionsRemoveItem(this.removeId);
			if (status) this.isRemove = false;
			// await this.onUpdateFilters(this.defaultFilter);
			this.externalRefresh();
		},
		async onEvent(flag) {
			if (flag === 'create') {
				this.isIncomeTransactionsForm = true;
				this.id = null;
			}
		},
		async onUpdateFilters(filters, isWithoutFilters) {
			await this.getIncomeTransactions(filters);
			if (!isWithoutFilters) await this.getIncomeTransactionsFilters(filters);
		},
		async onList(values) {
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getIncomeTransactions(value);
					break;
				case "page":
					await this.onUpdateFilters(value, true);
					break;
				default:
					await this.onUpdateFilters(value);
			}
		},
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'incomeTransactions' });
		},
		onCloseEditTransactions(isRefresh) {
			this.isEditTransactions = false;

			if (isRefresh) {
				this.externalRefresh();
			}
		},
		/**
		 * Save transaction customer.
		 *
		 * @param {Object} values Transaction values.
		 * @returns {Promise<void>}
		 */
		async onSaveEditTransactions(values) {
			const status = await this.onUpdateIncomeTransactions(values);

			if (!status) {
				return;
			}

			this.isEditTransactions = false;

			this.externalRefresh();
		},

		/**
		 * Closes paid transaction drawer.
		 *
		 * @param {Boolean} isRefresh Refresh table flag.
		 * @returns {void}
		 */
		onClosePaidTransactions(isRefresh) {
			this.isPaidTransactions = false;

			if (isRefresh) {
				this.externalRefresh();
			}
		},

		async onClickButton({ key, item }) {

			if (key === 'paid') {
				this.id = item.id;

				const data = await this.getPaidTransactionsData(item.id);

				if (data) {
					this.isPaidTransactions = true;
				}

				return;
			}

			if (key === 'edit1') {
				this.id = item.id;

				await this.onEditIncomeTransactions(item.id);

				this.isEditTransactions = true;

				return;
			}

			if (key === 'edit') {
				if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
					this.id = item.id;
					this.isIncomeTransactionsForm = true;
				}
			}

			if (key === "delete") {
				if (this.permissions[PERMISSIONS.DELETE]) {
					this.getRemoveItem(item.id);
				}
			}
		},
		onEdit({ line }) {
			if (this.permissions[PERMISSIONS.EDIT]) {
				this.id = line.id;
				this.isIncomeTransactionsForm = true;

			}
		},
		externalRefresh() {
			// обновить таблицу, сохранив текущие фильтры
			this.externalRefreshKey = getUniqId();
		},
		externalReset(mode) {
			// 'default' | 'empty' (default до дефолтних | empty усі фільтра)
			this.externalResetMode = mode;
			this.externalResetKey = getUniqId();
		},

	},
	async mounted() {
		await this.onUpdateFilters();
	}
};
</script>

<style lang="scss">
.payment-id {
	color: var(--card-color-sub-title);

	.value {
		color: var(--card-color);
	}
}
</style>
<style scoped lang="scss">

.incomeTransactionsUpdate {
	margin-left: 14px;

	&__content {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		gap: 5px;
	}

	&__head {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	&__icon {
		flex-shrink: 0;

		margin-right: 2px;

		color: var(--base-green);
		font-size: 20px;
	}

	&__text {
		color: var(--base-orange);
		font-size: 14px;
		line-height: 1.15;
	}

	&__date {
		color: var(--card-color);
		font-size: 12px;
		line-height: 1.15;
	}

	&__zones {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		border: 1px solid rgba(255, 255, 255, 0.07);
		border-radius: 5px;

		background: rgba(255, 255, 255, 0.025);

		overflow: hidden;
	}

	&__zone {
		display: flex;
		align-items: center;
		gap: 4px;

		padding: 3px 7px;

		white-space: nowrap;

		&:not(:last-child) {
			border-right: 1px solid rgba(255, 255, 255, 0.09);
		}
	}

	&__zoneCode {
		color: var(--base-green);
		font-size: 11px;
		font-weight: 600;
		line-height: 1;
	}

	&__zoneTime {
		color: var(--card-color-sub-title);
		font-size: 11px;
		line-height: 1;
	}
}

</style>
